module.exports = __webpack_public_path__ + "static/media/service_civique.cbde0274.jpg";